export const translations = {
  en: {
    appName: "VeiKlar",
    tagline: "Norwegian B1 driving theory, in your language.",
    heroSubtitle:
      "Built for English, Somali, and Arabic speakers in Norway. Learn the rules, master the signs, and pass your førerprøve.",
    signIn: "Sign in with Vipps",
    signOut: "Sign out",
    getStarted: "Get started",
    learnMore: "Learn more",
    dashboard: "Dashboard",
    learn: "Learn",
    practice: "Practice",
    mockExam: "Mock exam",
    signs: "Signs",
    markings: "Road markings",
    tutor: "AI Tutor",
    welcome: "Welcome back",
    keepGoing: "Keep going — every minute counts.",
    statTotal: "Total attempts",
    statMockBest: "Best mock score",
    statAccuracy: "Avg accuracy",
    statPractice: "Practice sessions",
    quickStart: "Quick start",
    fullMockExam: "Full mock exam",
    fullMockExamDesc: "45 timed questions, just like the official Statens vegvesen test.",
    startMock: "Start mock",
    practiceByTopic: "Practice by topic",
    practiceByTopicDesc: "Focus on areas you want to improve.",
    startPractice: "Start practice",
    aiTutor: "Ask the AI tutor",
    aiTutorDesc: "Explanations in your language by the AI tutor.",
    openTutor: "Open tutor",
    recentAttempts: "Recent attempts",
    noAttemptsYet: "No attempts yet. Start practicing!",
    topics: "Topics",
    lessons: "lessons",
    lessonAtAGlance: "In this lesson",
    topicHeroLabel: "What you'll learn",
    lessonKeySigns: "Key signs to recognize",
    lessonKeyRulesLabel: "Key rules",
    lessonSituationsLabel: "Real-world situations",
    lessonExamplesLabel: "Worked examples",
    lessonMistakesLabel: "Common mistakes",
    lessonReferencesLabel: "Official references",
    lessonWhatHappens: "What happens:",
    lessonWhatToDo: "What to do:",
    lessonSituation: "Situation:",
    lessonWhy: "Why:",
    lessonMistake: "Mistake:",
    lessonCorrection: "Correction:",
    lessonFullDetailBadge: "Full detail",
    learnTutorHint: "Stuck on a sentence? Select any text on this page and tap \"Ask AI Tutor\", or open the chat in the corner.",
    askAITutor: "Ask AI Tutor",
    askAITutorAboutThis: "Ask AI about this",
    tutorEmpty: "Ask anything — I'll answer in your language with Statens vegvesen references.",
    tutorExplainPrefix: "Explain this in simple terms:",
    tutorError: "Sorry, I couldn't respond. Please try again.",
    introBadge: "Aligned with Statens vegvesen",
    introTitle: "Why exactly these 7 topics?",
    introBody: "These are the seven official subject areas in the Class B theory curriculum (Læreplan klasse B, V851) used by every approved Norwegian driving school. The B1 theory exam draws every question from this exact curriculum — master these and you cover 100% of the test.",
    introRefVegvesen: "vegvesen.no — Get a driving licence",
    introRefLaereplan: "Læreplan V851 (Lovdata)",
    introRefVegtraf: "Vegtrafikkloven",
    backToTopics: "Back to topics",
    practiceTopic: "Practice this topic",
    select10: "10 questions",
    select20: "20 questions",
    selectTopic: "Choose a topic",
    allTopics: "All topics",
    question: "Question",
    of: "of",
    submit: "Submit",
    next: "Next",
    previous: "Previous",
    finish: "Finish",
    skip: "Skip",
    correct: "Correct",
    incorrect: "Incorrect",
    yourAnswer: "Your answer",
    correctAnswer: "Correct answer",
    explanation: "Explanation",
    score: "Score",
    passed: "Passed",
    failed: "Failed",
    timeLeft: "Time left",
    minutes: "min",
    seconds: "sec",
    // FIX: was "45 questions, 90 minutes" in confirmMock but "45 minutes" in mockSubtitle — now consistent
    confirmMock:
      "The mock exam mirrors the official Norwegian Class B theory test: 45 questions, 90 minutes, you need 38 correct to pass. You can move forwards and backwards between questions.",
    iAmReady: "I'm ready",
    cancel: "Cancel",
    askQuestion: "Ask anything about Norwegian driving rules…",
    send: "Send",
    thinking: "Thinking…",
    language: "Language",
    learnTitle: "Learning chapters",
    learnSubtitle: "Read concise lessons covering every test topic.",
    practiceTitle: "Practice quizzes",
    practiceSubtitle: "Short quizzes by topic. Get instant feedback.",
    mockTitle: "Mock theory exam",
    // FIX: was "45 minutes" — corrected to 90 minutes to match official test and confirmMock
    mockSubtitle: "45 questions • 90 minutes • 38 correct to pass.",
    signsTitle: "Traffic signs",
    signsSubtitle: "All categories of Norwegian road signs in one gallery.",
    signDetailGenerating: "Writing an easy-to-read explanation for this sign…",
    signDetailUnavailable: "We couldn't generate an explanation right now. Please try again in a moment.",
    markingsTitle: "Road markings (oppmerking)",
    markingsSubtitle: "Yellow & white lines, stop lines, yield triangles and pedestrian crossings — per Skiltforskriften §22.",
    // Road markings category tabs — FIX: were not translated (showed raw English to Arabic/Somali users)
    markingsCatAll: "All",
    markingsCatLane: "Lane markings",
    markingsCatEdge: "Edge lines",
    markingsCatStop: "Stop lines",
    markingsCatYield: "Yield markings",
    markingsCatPedestrian: "Pedestrian crossings",
    // Sign/marking detail modal labels — FIX: were hardcoded English
    whenYouSeeIt: "When you see it",
    whatToDo: "What to do",
    realSituations: "Real situations",
    oftenConfusedWith: "Often confused with",
    relatedSigns: "Related signs",
    askTutorAboutSign: "Ask the AI tutor about this sign",
    tutorTitle: "AI Driving Tutor",
    tutorSubtitle: "Ask anything about rules, signs, or a tricky question.",
    category: "Category",
    all: "All",
    warning: "Warning",
    prohibition: "Prohibition",
    mandatory: "Mandatory",
    priority: "Priority",
    information: "Information",
    backToDashboard: "Back to dashboard",
    reviewAnswers: "Review answers",
    tryAgain: "Try again",
    explainThis: "Explain this question",
    yourScore: "Your score",
    accuracy: "Accuracy",
    duration: "Duration",
    passMark: "Pass mark",
    loading: "Loading…",
    signInToContinue: "Sign in to continue",
    signInDesc: "Use your Google account to track progress across devices.",
    // FIX: removed "(RTL)" from features1 — technical term not relevant to users
    features1: "All three languages — English, Somali, and Arabic.",
    features2: "Real exam-style mock test: 45 questions, 90 minutes, 38 correct to pass.",
    features3: "AI tutor that answers in your language, citing official Norwegian rules.",
    features4: "Traffic signs gallery with descriptions.",
    officialNotice:
      "Content aligned with Statens vegvesen (vegvesen.no) and Læreplan V851. The official Class B test is offered in Norwegian, English, Arabic (MSA), Northern Sami, Sorani and Turkish — Somali content here is provided for learning support only.",
    sourceBadge: "Aligned with Statens vegvesen",
    liveData: "Live data",
    nvdbWidgetTitle: "Real road from Norway",
    nvdbWidgetSubtitle: "A live posted speed limit from the National Road Database.",
    postedSpeedLimit: "Posted speed limit",
    roadReference: "Road reference",
    validFrom: "Valid from",
    refresh: "Refresh",
    nvdbError: "Couldn't reach the National Road Database. Try again in a moment.",
    commonMistakeLabel: "Common mistake",
    riskWhyMattersLabel: "Why this matters",
    driverActionLabel: "Driver action",
    realRoadQuizTitle: "Real-Road Quiz",
    realRoadQuizSubtitle: "5 quick questions on actual speed limits from Norway's National Road Database. Real road references, today's posted limits — answer like you're already driving there.",
    realRoadQuizCta: "Start Real-Road Quiz",
    selectSubtopic: "Sub-topic (optional)",
    anySubtopic: "Any sub-topic",
    popularSubtopics: "Drill a specific sub-topic",
    popularSubtopicsHint: "— sorted by how many questions are ready",
    weakSubtopicLabel: "Focus area",
    weakSubtopicHeadline: "Your weakest sub-topic is",
    weakSubtopicHint: "10 quick questions targeted at this gap — practice now and we'll re-check tomorrow.",
    weakSubtopicCta: "Re-drill now",
    phaseAll: "All phases",
    phaseOne: "Phase 1",
    phaseTwo: "Phase 2",
    phaseThree: "Phase 3",
    phaseFour: "Phase 4",
    // Coverage page
    coverageTitle: "Coverage matrix",
    coverageSubtitle: "Topic coverage aligned with Læreplan V851. Tracks how many questions exist for each Norwegian theory sub-topic.",
    coverageTotalQuestions: "Total questions",
    coverageEnrichedQuestions: "Enriched questions",
    coverageStatusComplete: "Complete",
    coverageStatusInProgress: "In progress",
    coverageStatusMissing: "Missing",
    coverageColPhase: "Phase",
    coverageColTopic: "Topic / sub-topic",
    coverageColRule: "Rule source",
    coverageColTarget: "Target",
    coverageColCurrent: "Current",
    coverageColGap: "Gap",
    coverageColStatus: "Status",
    coverageColTypes: "Question types",
    coverageBackToDashboard: "Back to dashboard",
    // FIX: was hardcoded English in Coverage.jsx
    coveragePhaseProgress: "Phase 1–4 progress",
    // FIX: missing keys used in Quiz.jsx — showed raw key names to users
    noQuestionsForTopic: "No questions available for this selection yet. Please try another topic.",
    loadFailed: "Couldn't load the quiz. Please try again.",
    submitFailed: "Submission failed. Please try again.",
    // FIX: missing key used in Quiz.jsx timer
    timeUp: "Time's up! Submitting your answers…",
    // Practice page
    questionsReady: "questions ready",
    moreComing: "more coming",
  },

  so: {
    appName: "VeiKlar",
    tagline: "Imtixaanka aragtida wadista B1 ee Norway, luqaddaada.",
    heroSubtitle:
      "Loogu sameeyay kuwa ku hadla Ingiriis, Soomaali, iyo Carabi ee Norway. Baro xeerarka, calaamadaha, oo guuli førerprøve-ka.",
    signIn: "Ku gal Vipps",
    signOut: "Ka bax",
    getStarted: "Bilow",
    learnMore: "Wax badan baro",
    dashboard: "Dashboorka",
    learn: "Barashada",
    practice: "Tababar",
    mockExam: "Imtixaan tijaabo",
    signs: "Calaamadaha",
    markings: "Sumadaha waddada",
    tutor: "Macallin AI",
    welcome: "Soo dhowow",
    keepGoing: "Sii wad — daqiiqad walba way muhiim tahay.",
    statTotal: "Wadarta isku dayga",
    statMockBest: "Buundo tijaabo ugu fiican",
    statAccuracy: "Saxnaanta celcelis",
    statPractice: "Fadhiyada tababarka",
    quickStart: "Bilow degdeg ah",
    fullMockExam: "Imtixaan dhammaystiran",
    fullMockExamDesc: "45 su'aalood oo wakhti leh, sida imtixaanka rasmiga ee Statens vegvesen.",
    startMock: "Bilow imtixaan",
    practiceByTopic: "Tababar mowduuc",
    practiceByTopicDesc: "Diiradda saar meelaha aad rabto inaad horumariso.",
    startPractice: "Bilow tababar",
    aiTutor: "Weydii macallinka AI",
    aiTutorDesc: "Sharaxaad luqaddaada ah oo macallinka AI keenay.",
    openTutor: "Fur macallin",
    recentAttempts: "Isku dayadii ugu dambeysay",
    noAttemptsYet: "Wali isku day ma jiro. Bilow tababar!",
    topics: "Mowduucyada",
    lessons: "casharo",
    lessonAtAGlance: "Casharkan",
    topicHeroLabel: "Waxa aad baran doonto",
    lessonKeySigns: "Calaamadaha muhiimka ah ee la aqoonsado",
    lessonKeyRulesLabel: "Xeerarka muhiimka ah",
    lessonSituationsLabel: "Xaalado dunida dhabta ah",
    lessonExamplesLabel: "Tusaalooyin la xalliyay",
    lessonMistakesLabel: "Khaladaadka caadiga ah",
    lessonReferencesLabel: "Tixraacyo rasmi ah",
    lessonWhatHappens: "Maxaa dhacaya:",
    lessonWhatToDo: "Maxaad samaynaysaa:",
    lessonSituation: "Xaaladda:",
    lessonWhy: "Sababta:",
    lessonMistake: "Khalad:",
    lessonCorrection: "Saxidda:",
    lessonFullDetailBadge: "Faahfaahin buuxda",
    learnTutorHint: "Ma fahmin jumlad? Dooro qoraal kasta oo bogganaa oo riix \"Weydii Macallinka AI\", ama fur sheekada gembi.",
    askAITutor: "Weydii Macallinka AI",
    askAITutorAboutThis: "Weydii AI tan",
    tutorEmpty: "Wax kasta i weydii — luqaddaada ayaan kugu jawaabi doonaa, anigoo tixraacaya Statens vegvesen.",
    tutorExplainPrefix: "Sii sharax tan si fudud:",
    tutorError: "Waan ka xunahay, ma jawaabi karo. Fadlan isku day mar kale.",
    introBadge: "Waafaqsan Statens vegvesen",
    introTitle: "Maxaa loo doortay todobadan oo mowduuc?",
    introBody: "Kuwani waa todobada qaybood ee rasmiga ah ee manhajka aragtida fasalka B (Læreplan klasse B, V851) ay isticmaalaan dhammaan iskuulada wadista ee Norway. Imtixaanka aragtida B1 dhammaan su'aalihiisa ka soo qaadasho manhajkan — markaad si fiican u barato, 100% imtixaanka ayaad daboolaysaa.",
    introRefVegvesen: "vegvesen.no — Hel shati wadis",
    introRefLaereplan: "Læreplan V851 (Lovdata)",
    introRefVegtraf: "Sharciga Trafikada",
    backToTopics: "Ku noqo mowduucyada",
    practiceTopic: "Tababar mowduucan",
    select10: "10 su'aalood",
    select20: "20 su'aalood",
    selectTopic: "Dooro mowduuc",
    allTopics: "Dhammaan mowduucyada",
    question: "Su'aal",
    of: "ka",
    submit: "Soo gudbi",
    next: "Soo socda",
    previous: "Hore",
    finish: "Dhammee",
    skip: "Ka bood",
    correct: "Sax",
    incorrect: "Khalad",
    yourAnswer: "Jawaabtaada",
    correctAnswer: "Jawaabta saxda ah",
    explanation: "Sharraxaad",
    score: "Buundo",
    passed: "Waad guuleysatay",
    failed: "Ma aadan guuleysan",
    timeLeft: "Waqti haray",
    minutes: "daqiiqo",
    seconds: "ilbiriqsi",
    confirmMock:
      "Imtixaankan tijaabadu wuxuu u dhigmayaa imtixaanka rasmiga ah ee Class B: 45 su'aalood, 90 daqiiqo, 38 sax oo aad u baahan tahay si aad u guuleyso. Waxaad u dhaqaaqi kartaa hore iyo dib.",
    iAmReady: "Diyaar baan ahay",
    cancel: "Jooji",
    askQuestion: "Weydii wax kasta oo ku saabsan xeerarka wadista Norway…",
    send: "Dir",
    thinking: "Waan ka fakireynayaa…",
    language: "Luqad",
    learnTitle: "Cutubbada barashada",
    learnSubtitle: "Akhri casharrada gaaban ee dabboolaya mowduuc kasta.",
    practiceTitle: "Tababarka su'aalaha",
    practiceSubtitle: "Su'aalo gaaban mowduuc kasta. Hel jawaab degdeg ah.",
    mockTitle: "Imtixaan tijaabo",
    // FIX: was correct in Somali already (90 daqiiqo) — kept as is
    mockSubtitle: "45 su'aalood • 90 daqiiqo • 38 sax oo ka mid ah 45 si aad u guuleyso.",
    signsTitle: "Calaamadaha taraafikada",
    signsSubtitle: "Dhammaan qaybaha calaamadaha waddooyinka Norway hal goob.",
    signDetailGenerating: "Waxaa la qorayaa sharraxaad fudud oo ku saabsan calaamaddan…",
    signDetailUnavailable: "Ma awoodi karno inaan abuurno sharraxaad hadda. Fadlan dib u isku day daqiiqad gudaheeda.",
    markingsTitle: "Sumadaha waddada (oppmerking)",
    markingsSubtitle: "Khadadka jaalaha iyo cadda, khadadka joojinta iyo zebra-cross — Skiltforskriften §22.",
    // FIX: road markings category tabs now translated
    markingsCatAll: "Dhammaan",
    markingsCatLane: "Xarriiqyada dariiqa",
    markingsCatEdge: "Xarriiqyada dhinaca",
    markingsCatStop: "Xarriiqyada joojinta",
    markingsCatYield: "Sumadaha vikeplikt",
    markingsCatPedestrian: "Kabka lugaynta",
    // FIX: sign/marking detail modal labels now translated
    whenYouSeeIt: "Marka aad aragtid",
    whatToDo: "Maxaad samaynaysaa",
    realSituations: "Xaalado dhabta ah",
    oftenConfusedWith: "Inta badan la wareegsadaa",
    relatedSigns: "Calaamadaha la xiriira",
    askTutorAboutSign: "Weydii macallinka AI calaamaddan",
    tutorTitle: "Macallin AI",
    tutorSubtitle: "Weydii wax ku saabsan xeerarka, calaamadaha, ama su'aal adag.",
    category: "Qayb",
    all: "Dhammaan",
    warning: "Digniin",
    prohibition: "Mamnuuc",
    mandatory: "Waajib",
    priority: "Mudnaan",
    information: "Macluumaad",
    backToDashboard: "Ku noqo dashboorka",
    reviewAnswers: "Eeg jawaabaha",
    tryAgain: "Mar kale isku day",
    explainThis: "Ii sharax su'aashan",
    yourScore: "Buundadaada",
    accuracy: "Saxnaanta",
    duration: "Muddo",
    passMark: "Heerka guulaha",
    loading: "Soo dejinayaa…",
    signInToContinue: "Soo gal si aad u sii waddo",
    signInDesc: "Isticmaal akoonkaaga Google si aad u raadiso horumarkaaga.",
    // FIX: removed "(RTL)" — not relevant to users
    features1: "Saddexda luqadood — Ingiriis, Soomaali, iyo Carabi.",
    features2: "Imtixaan tijaabo sida dhabta: 45 su'aal, 90 daqiiqo, 38 sax si aad u guuleyso.",
    features3: "Macallin AI oo kuugu jawaaba luqaddaada, isagoo soo xiganaya xeerarka rasmiga ah ee Norway.",
    features4: "Bandhig calaamadaha taraafikada oo sharraxaad leh.",
    officialNotice:
      "Waxay la jaanqaadeysaa Statens vegvesen (vegvesen.no) iyo Læreplan V851. Imtixaanka rasmiga ah ee Class B waxaa lagu bixiyaa Norweyga, Ingiriis, Carabi (MSA), Saami Waqooyi, Sorani iyo Turki — Soomaaliga halkan waxaa loogu talagalay caawimaad barashada oo keliya.",
    sourceBadge: "La jaanqaadayo Statens vegvesen",
    liveData: "Xog toos ah",
    nvdbWidgetTitle: "Waddo dhab ah oo Norway ah",
    nvdbWidgetSubtitle: "Xadka xawaaraha rasmiga ah oo ka socda kaydka qaranka ee waddooyinka.",
    postedSpeedLimit: "Xadka xawaaraha la dejiyay",
    roadReference: "Tixraaca waddada",
    validFrom: "Laga bilaabo",
    refresh: "Cusboonaysii",
    nvdbError: "Lama gaari karo kaydka waddooyinka. Daqiiqad ka dib mar kale isku day.",
    commonMistakeLabel: "Khalad caadi ah",
    riskWhyMattersLabel: "Sababta ay arrintan u muhiim tahay",
    driverActionLabel: "Tallaabada wadaha",
    realRoadQuizTitle: "Imtixaanka Waddo-Dhab-ah",
    realRoadQuizSubtitle: "5 su'aalood degdeg ah oo ku saabsan xadka xawaaraha waddooyinka Norway oo ka socda kaydka qaranka. Tixraacyo waddo dhab ah, xadka xawaaraha maanta — jawaab sida adigoo halkaas ka socda.",
    realRoadQuizCta: "Bilow Imtixaanka",
    // FIX: these 6 keys were missing in Somali — fell back to English
    selectSubtopic: "Qaybta (ikhtiyaari)",
    anySubtopic: "Qayb kasta",
    popularSubtopics: "Ka shaqee qayb gaar ah",
    popularSubtopicsHint: "— u kala soocan tirada su'aalaha diyaarka ah",
    weakSubtopicLabel: "Goobta diiradda",
    weakSubtopicHeadline: "Mawduuca aad ugu daciifsan tahay waa",
    weakSubtopicHint: "10 su'aalood degdeg ah oo bartilmaameedsan farqigan — hadda tababar, berito ayaan dib u eegi doonnaa.",
    weakSubtopicCta: "Dib u tababar hadda",
    phaseAll: "Dhammaan marxaladaha",
    phaseOne: "Marxalad 1",
    phaseTwo: "Marxalad 2",
    phaseThree: "Marxalad 3",
    phaseFour: "Marxalad 4",
    coverageTitle: "Shaxda kaydka mowduucyada",
    coverageSubtitle: "Daboolida mowduucyada oo la jaanqaadeysa Læreplan V851. Waxay raacaysaa imisa su'aalood oo dhameystiran mowduuc kasta.",
    coverageTotalQuestions: "Wadarta su'aalaha",
    coverageEnrichedQuestions: "Su'aalaha la horumariyay",
    coverageStatusComplete: "Dhameystiran",
    coverageStatusInProgress: "Socda",
    coverageStatusMissing: "Maqan",
    coverageColPhase: "Wajiga",
    coverageColTopic: "Mowduuca / qaybta",
    coverageColRule: "Ilaha sharcigu",
    coverageColTarget: "Yoolka",
    coverageColCurrent: "Hadda",
    coverageColGap: "Farqi",
    coverageColStatus: "Xaalad",
    coverageColTypes: "Noocyada su'aalaha",
    coverageBackToDashboard: "Ku noqo bogga hore",
    coveragePhaseProgress: "Horumarinta marxaladaha 1–4",
    // FIX: missing quiz error keys
    noQuestionsForTopic: "Su'aalo lama helin xulashadaan. Fadlan isku day mowduuc kale.",
    loadFailed: "Imtixaanka lama soo dejin karo. Fadlan isku day mar kale.",
    submitFailed: "Gudbinta way fashilantay. Fadlan isku day mar kale.",
    timeUp: "Waqtiga waa dhamaaday! Jawaabaha ayaa la gudbinayaa…",
    questionsReady: "su'aalood diyaar ah",
    moreComing: "wax badan ayaa imanaya",
  },

  ar: {
    appName: "VeiKlar",
    tagline: "اختبار النظري النرويجي B1 بلغتك.",
    heroSubtitle:
      "صُمِّم للناطقين بالإنجليزية والصومالية والعربية في النرويج. تعلّم القواعد وأتقن الإشارات واجتز اختبار førerprøve.",
    signIn: "تسجيل الدخول بـ Vipps",
    signOut: "تسجيل الخروج",
    getStarted: "ابدأ الآن",
    learnMore: "اعرف المزيد",
    dashboard: "لوحة التحكم",
    learn: "تعلُّم",
    practice: "تدريب",
    mockExam: "اختبار تجريبي",
    signs: "الإشارات",
    markings: "علامات الطريق",
    tutor: "المدرس الذكي",
    welcome: "مرحبًا بعودتك",
    keepGoing: "واصل التقدم — كل دقيقة لها قيمة.",
    statTotal: "إجمالي المحاولات",
    statMockBest: "أفضل نتيجة تجريبية",
    statAccuracy: "متوسط الدقة",
    statPractice: "جلسات التدريب",
    quickStart: "بداية سريعة",
    fullMockExam: "اختبار تجريبي كامل",
    fullMockExamDesc: "45 سؤالًا بمؤقت، تمامًا كاختبار Statens vegvesen الرسمي.",
    startMock: "ابدأ الاختبار",
    practiceByTopic: "تدرب حسب الموضوع",
    practiceByTopicDesc: "ركّز على المجالات التي تريد تحسينها.",
    startPractice: "ابدأ التدريب",
    aiTutor: "اسأل المدرس الذكي",
    aiTutorDesc: "شروحات بلغتك بواسطة المدرس الذكي.",
    openTutor: "افتح المدرس",
    recentAttempts: "أحدث المحاولات",
    noAttemptsYet: "لا توجد محاولات بعد. ابدأ التدرب!",
    topics: "المواضيع",
    lessons: "دروس",
    lessonAtAGlance: "في هذا الدرس",
    topicHeroLabel: "ما ستتعلمه",
    lessonKeySigns: "أهم اللافتات لتتعرف عليها",
    lessonKeyRulesLabel: "القواعد الأساسية",
    lessonSituationsLabel: "مواقف من الواقع",
    lessonExamplesLabel: "أمثلة محلولة",
    lessonMistakesLabel: "أخطاء شائعة",
    lessonReferencesLabel: "المراجع الرسمية",
    lessonWhatHappens: "ما يحدث:",
    lessonWhatToDo: "ما يجب فعله:",
    lessonSituation: "الحالة:",
    lessonWhy: "السبب:",
    lessonMistake: "الخطأ:",
    lessonCorrection: "التصحيح:",
    lessonFullDetailBadge: "تفاصيل كاملة",
    learnTutorHint: "لم تفهم جملة؟ حدد أي نص في الصفحة واضغط \"اسأل المعلم الذكي\"، أو افتح المحادثة في الزاوية.",
    askAITutor: "اسأل المعلم الذكي",
    askAITutorAboutThis: "اسأل عن هذا",
    tutorEmpty: "اسأل أي شيء — سأجيبك بلغتك مع مراجع من Statens vegvesen.",
    tutorExplainPrefix: "اشرح لي هذا ببساطة:",
    tutorError: "آسف، لم أتمكن من الرد. يرجى المحاولة مرة أخرى.",
    introBadge: "متوافق مع Statens vegvesen",
    introTitle: "لماذا هذه السبعة موضوعات بالضبط؟",
    introBody: "هذه هي مجالات الدراسة السبعة الرسمية في منهج النظرية للفئة B (Læreplan klasse B, V851) المستخدم في جميع مدارس القيادة المعتمدة في النرويج. يُستمد كل سؤال في امتحان النظرية B1 من هذا المنهج بالضبط — أتقن هذه الموضوعات لتغطي 100٪ من الامتحان.",
    introRefVegvesen: "vegvesen.no — الحصول على رخصة قيادة",
    introRefLaereplan: "منهج V851 (Lovdata)",
    introRefVegtraf: "قانون المرور",
    backToTopics: "العودة للمواضيع",
    practiceTopic: "تدرب على هذا الموضوع",
    select10: "10 أسئلة",
    select20: "20 سؤالًا",
    selectTopic: "اختر موضوعًا",
    allTopics: "كل المواضيع",
    question: "سؤال",
    of: "من",
    submit: "إرسال",
    next: "التالي",
    previous: "السابق",
    finish: "إنهاء",
    skip: "تخطّي",
    correct: "صحيح",
    incorrect: "خاطئ",
    yourAnswer: "إجابتك",
    correctAnswer: "الإجابة الصحيحة",
    explanation: "الشرح",
    score: "النتيجة",
    passed: "ناجح",
    failed: "راسب",
    timeLeft: "الوقت المتبقي",
    minutes: "دقيقة",
    seconds: "ثانية",
    confirmMock:
      "يحاكي هذا الاختبار التجريبي اختبار النرويج الرسمي للفئة B: 45 سؤالًا، 90 دقيقة، تحتاج 38 إجابة صحيحة للنجاح. يمكنك التنقل بين الأسئلة للأمام والخلف.",
    iAmReady: "أنا جاهز",
    cancel: "إلغاء",
    askQuestion: "اسأل أي شيء عن قواعد القيادة في النرويج…",
    send: "إرسال",
    thinking: "أفكّر…",
    language: "اللغة",
    learnTitle: "فصول التعلم",
    learnSubtitle: "اقرأ دروسًا موجزة تغطي كل موضوع.",
    practiceTitle: "اختبارات التدريب",
    practiceSubtitle: "اختبارات قصيرة حسب الموضوع مع تقييم فوري.",
    mockTitle: "اختبار النظري التجريبي",
    // Arabic was already correct (90 دقيقة) — kept as is
    mockSubtitle: "45 سؤالًا • 90 دقيقة • 38 صحيحًا من 45 للنجاح.",
    signsTitle: "إشارات المرور",
    signsSubtitle: "جميع فئات إشارات الطرق النرويجية في معرض واحد.",
    signDetailGenerating: "نقوم بكتابة شرح مبسط لهذه الإشارة…",
    signDetailUnavailable: "تعذّر إنشاء الشرح الآن. يرجى المحاولة بعد لحظة.",
    markingsTitle: "علامات الطريق (oppmerking)",
    markingsSubtitle: "الخطوط الصفراء والبيضاء، خطوط التوقف، مثلثات الإفساح وممرات المشاة — Skiltforskriften §22.",
    // FIX: road markings category tabs now translated
    markingsCatAll: "الكل",
    markingsCatLane: "خطوط المسار",
    markingsCatEdge: "خطوط الحافة",
    markingsCatStop: "خطوط التوقف",
    markingsCatYield: "علامات الإفساح",
    markingsCatPedestrian: "ممرات المشاة",
    // FIX: sign/marking detail modal labels now translated
    whenYouSeeIt: "عند رؤيتها",
    whatToDo: "ما يجب فعله",
    realSituations: "مواقف حقيقية",
    oftenConfusedWith: "كثيرًا ما تُخلط مع",
    relatedSigns: "إشارات ذات صلة",
    askTutorAboutSign: "اسأل المدرس الذكي عن هذه الإشارة",
    tutorTitle: "مدرس القيادة الذكي",
    tutorSubtitle: "اسأل عن أي قاعدة أو إشارة أو سؤال صعب.",
    category: "الفئة",
    all: "الكل",
    warning: "تحذير",
    prohibition: "حظر",
    mandatory: "إلزامي",
    priority: "أولوية",
    information: "معلومات",
    backToDashboard: "العودة للوحة التحكم",
    reviewAnswers: "مراجعة الإجابات",
    tryAgain: "حاول مرة أخرى",
    explainThis: "اشرح هذا السؤال",
    yourScore: "نتيجتك",
    accuracy: "الدقة",
    duration: "المدة",
    passMark: "حد النجاح",
    loading: "جارٍ التحميل…",
    signInToContinue: "سجّل الدخول للمتابعة",
    signInDesc: "استخدم حساب Google لمتابعة تقدمك عبر الأجهزة.",
    // FIX: removed "(RTL)" — technical term not relevant to Arabic users
    features1: "اللغات الثلاث — الإنجليزية والصومالية والعربية.",
    features2: "اختبار تجريبي حقيقي: 45 سؤالًا، 90 دقيقة، 38 إجابة صحيحة للنجاح.",
    features3: "مدرّس ذكي يجيبك بلغتك مستشهدًا بالقواعد النرويجية الرسمية.",
    features4: "معرض إشارات المرور مع الشروحات.",
    officialNotice:
      "متوافق مع Statens vegvesen (vegvesen.no) ومنهج Læreplan V851. اختبار الفئة B الرسمي متوفر بالنرويجية والإنجليزية والعربية (الفصحى) والسامية الشمالية والسورانية والتركية — اللغة الصومالية هنا للدعم التعليمي فقط.",
    sourceBadge: "متوافق مع Statens vegvesen",
    liveData: "بيانات مباشرة",
    nvdbWidgetTitle: "طريق حقيقي من النرويج",
    nvdbWidgetSubtitle: "حد سرعة مُوقَّع مباشر من قاعدة بيانات الطرق الوطنية.",
    postedSpeedLimit: "حد السرعة المُوقَّع",
    roadReference: "مرجع الطريق",
    validFrom: "ساري من",
    refresh: "تحديث",
    nvdbError: "تعذّر الوصول إلى قاعدة بيانات الطرق الوطنية. أعد المحاولة بعد لحظة.",
    commonMistakeLabel: "خطأ شائع",
    riskWhyMattersLabel: "لماذا يهم هذا",
    driverActionLabel: "إجراء السائق",
    realRoadQuizTitle: "اختبار الطريق الحقيقي",
    realRoadQuizSubtitle: "5 أسئلة سريعة حول حدود السرعة الفعلية من قاعدة بيانات الطرق الوطنية في النرويج. مراجع طرق حقيقية وحدود اليوم — أجب كأنك تقود هناك بالفعل.",
    realRoadQuizCta: "ابدأ اختبار الطريق الحقيقي",
    selectSubtopic: "الموضوع الفرعي (اختياري)",
    anySubtopic: "أي موضوع فرعي",
    popularSubtopics: "تدرّب على موضوع فرعي محدد",
    popularSubtopicsHint: "— مرتّب حسب عدد الأسئلة الجاهزة",
    weakSubtopicLabel: "نقطة التركيز",
    weakSubtopicHeadline: "موضوعك الأضعف هو",
    weakSubtopicHint: "10 أسئلة سريعة تستهدف هذه الفجوة — تدرّب الآن وسنُعيد الفحص غدًا.",
    weakSubtopicCta: "تدرّب الآن",
    phaseAll: "كل المراحل",
    phaseOne: "المرحلة 1",
    phaseTwo: "المرحلة 2",
    phaseThree: "المرحلة 3",
    phaseFour: "المرحلة 4",
    coverageTitle: "مصفوفة التغطية",
    // FIX: "فلسفيًا" removed — confusing word for Arabic users
    coverageSubtitle: "تغطية المواضيع متوافقة مع Læreplan V851. تتتبع عدد الأسئلة الشاملة لكل موضوع فرعي في النظرية النرويجية.",
    coverageTotalQuestions: "إجمالي الأسئلة",
    coverageEnrichedQuestions: "الأسئلة الشاملة",
    coverageStatusComplete: "مكتمل",
    coverageStatusInProgress: "قيد التقدم",
    coverageStatusMissing: "ناقص",
    coverageColPhase: "المرحلة",
    coverageColTopic: "الموضوع / الفرعي",
    coverageColRule: "المصدر القانوني",
    coverageColTarget: "الهدف",
    coverageColCurrent: "الحالي",
    coverageColGap: "الفجوة",
    coverageColStatus: "الحالة",
    coverageColTypes: "أنواع الأسئلة",
    coverageBackToDashboard: "العودة إلى لوحة التحكم",
    // FIX: was hardcoded English in Coverage.jsx
    coveragePhaseProgress: "تقدم المراحل 1–4",
    // FIX: missing keys used in Quiz.jsx
    noQuestionsForTopic: "لا توجد أسئلة متاحة لهذا الاختيار بعد. يرجى تجربة موضوع آخر.",
    loadFailed: "تعذّر تحميل الاختبار. يرجى المحاولة مرة أخرى.",
    submitFailed: "فشل الإرسال. يرجى المحاولة مرة أخرى.",
    timeUp: "انتهى الوقت! جارٍ إرسال إجاباتك…",
    questionsReady: "سؤال جاهز",
    moreComing: "المزيد قادم",
  },
};